/* Mahi Wairua video cards.
   - The <video> has no src until the visitor presses play, so nothing downloads before then.
   - Native controls appear on activation; no autoplay, no loop.
   - Starting any video on the page pauses every other playing video (including product-gallery videos). */
(() => {
  if (window.__mahiVideoCards) return;
  window.__mahiVideoCards = true;

  const activate = (button) => {
    const frame = button.closest('.mahi-vc__frame');
    const video = frame && frame.querySelector('video.mahi-vc__video');
    if (!video) return;
    if (!video.getAttribute('src') && !video.querySelector('source')) {
      const src = video.dataset.src;
      if (!src) return;
      const source = document.createElement('source');
      source.src = src;
      if (video.dataset.type) source.type = video.dataset.type;
      video.appendChild(source);
      video.load();
    }
    video.controls = true;
    frame.classList.add('is-active');
    button.hidden = true;
    const played = video.play();
    if (played && typeof played.catch === 'function') played.catch(() => { /* user can still use native controls */ });
    video.focus({ preventScroll: true });
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.mahi-vc__play');
    if (button) activate(button);
  });

  // Pause every other video when one starts. 'play' does not bubble, so listen in the capture phase.
  document.addEventListener('play', (event) => {
    const current = event.target;
    if (!(current instanceof HTMLMediaElement)) return;
    document.querySelectorAll('video, audio').forEach((media) => {
      if (media !== current && !media.paused) media.pause();
    });
  }, true);
})();
